import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const AccountActionsEdit = ({ account, company, subcompany, t, handleClick = () => {} }) => (
  <Form.Link
    className={'btn btn-outline-primary btn-sm mx-1'}
    to={createRoute(company.id, subcompany.id, `accounts/${account.id}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(AccountActionsEdit);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/list/actions/AccountsActionsEdit.js